import store from '@/store/index'

export const PERMISSION_DENIED_MESSAGE = '許可されていないアクションです'

// 指定した auth getter が false の場合に権限なしを通知してリダイレクトするガードを生成する
const createRoleGuard = (getterKey) => (redirectPath) => (to, from, next) => {
  if (!store.getters[getterKey]) {
    store.commit('notify/set', {message: PERMISSION_DENIED_MESSAGE})
    next(redirectPath)
    return
  }
  next()
}

// テナント管理者のみ通過できる
export const isManagerGuard = createRoleGuard('auth/isManager')

// テナント管理者・限定指導者が通過できる
export const isAnyManagerGuard = createRoleGuard('auth/isAnyManager')

// profileの各edit画面は本人のみアクセスできるようにする
export const profileEditGuard = (to, from, next) => {
  if (to.params.id === store.state.auth.user.id) {
    next()
    return
  }
  store.commit('notify/set', {message: PERMISSION_DENIED_MESSAGE})
  next(`/members/${to.params.id}`)
}

export const availablePathNamesForParentMember = ['events', 'settings', 'members', 'goalList', 'mandalaEvaluation']
